import { render, staticRenderFns } from "./rp-roles-control.vue?vue&type=template&id=15921ade"
import script from "./rp-roles-control.vue?vue&type=script&lang=js"
export * from "./rp-roles-control.vue?vue&type=script&lang=js"
import style0 from "./rp-roles-control.vue?vue&type=style&index=0&id=15921ade&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports